import React from 'react'
import PropTypes from 'prop-types'
import { DOESNT_HAVE_N_LEVEL_VEHICLE, NEEDED_VEHICLES_OF_LEVEL } from './translations'
import styles from './NoVehicles.scss'

export const NoVehicles = props => (
    <section className={styles.base}>
        <p>{DOESNT_HAVE_N_LEVEL_VEHICLE(props.level)}</p>
        <p>{NEEDED_VEHICLES_OF_LEVEL(props.level)}</p>
    </section>
)

NoVehicles.propTypes = {
    level: PropTypes.number.isRequired,
}

export default NoVehicles



// WEBPACK FOOTER //
// ./containers/BattleRooms/containers/PlayersMatchingView/components/NoVehicles/NoVehicles.jsx